import React from 'react';

// Card for `kind: "directory.results"`. Emitted by
// directory_endpoints.find_stations alongside its chat-text answer: the same
// station hits, structured. On /dashboard the embed renders these itself
// (StationGrid); this plugin covers the Guide's own station page, where the
// card lands in the output panel.
//
// Expected structured shape (items are public-catalog entries, verbatim):
//   { kind: "directory.results", query: "vietnamese", total: 3,
//     items: [{ slug, network, network_name, headline, description, url, … }] }
export default function DirectoryResultsCard({ structured }) {
  const items = structured.items || [];
  const extra = (structured.total || items.length) - items.length;
  return (
    <div style={{
      marginBottom: '10px', padding: '12px', background: '#f8f9fa',
      borderRadius: '8px', border: '1px solid #e9ecef',
    }}>
      <div style={{ fontSize: '0.8rem', color: '#666', marginBottom: '8px' }}>
        Stations matching “{structured.query}”
      </div>
      {items.map((s) => (
        <div key={`${s.network}/${s.slug}`} style={{ marginBottom: '10px' }}>
          {/* href guard (!379 review): s.url is catalog-constructed and
              site-relative today — keep it that way defensively. */}
          {(s.url || '').startsWith('/') ? (
            <a href={s.url} style={{
              fontSize: '1rem', fontWeight: 700, color: '#0084ff',
              textDecoration: 'none',
            }}>
              {s.headline || s.slug}
            </a>
          ) : (
            <span style={{ fontSize: '1rem', fontWeight: 700 }}>
              {s.headline || s.slug}
            </span>
          )}
          <span style={{ fontSize: '0.78rem', color: '#888', marginLeft: '8px' }}>
            {s.network_name || s.network}
          </span>
          {s.description && (
            <div style={{ fontSize: '0.85rem', color: '#444', lineHeight: 1.4 }}>
              {s.description}
            </div>
          )}
        </div>
      ))}
      {extra > 0 && (
        <div style={{ fontSize: '0.78rem', color: '#888' }}>
          …and {extra} more in the directory.
        </div>
      )}
    </div>
  );
}
